import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

var NetworkError =
/*#__PURE__*/
function (_Error) {
  _inherits(NetworkError, _Error);

  function NetworkError(error, xhr) {
    var _this;

    _classCallCheck(this, NetworkError);

    if (xhr === void 0) {
      xhr = null;
    }

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NetworkError).call(this, "This looks like a network error, the endpoint might be blocked by an internet provider or a firewall."));
    _this.cause = error;
    _this.isNetworkError = true;
    _this.request = xhr;
    return _this;
  }

  return NetworkError;
}(_wrapNativeSuper(Error));

export default NetworkError;